import {Drawer, IconButton} from "@mui/material";
import {IconMenu} from "@bounce/shared/consumer/bounce-ui";
import {Colors} from "@bounce/shared/ui";
import {useConsumerMenu} from "./context/MenuContext";
import React, {ReactNode} from "react";

interface Props {
  children: ReactNode;
}

const ConsumerMenuDrawer = ({children}: Props) => {
  const {open, handleOpen, handleClose} = useConsumerMenu();

  return (
    <>
      <IconButton onClick={handleOpen}>
        <IconMenu color={Colors.primary._800} />
      </IconButton>
      <Drawer
        anchor="left"
        open={open}
        onClose={handleClose}
        slotProps={{
          paper: {
            sx: {
              width: 360,
              padding: "8px",
            },
          },
        }}
      >
        {children}
      </Drawer>
    </>
  );
};

export default ConsumerMenuDrawer;
